const intervals = {
  1: { label: 'Weekly', cadence: 'per week' },
  2: { label: 'Every 2 weeks', cadence: 'every 2 weeks' },
  3: { label: 'Monthly', cadence: 'per month' },
  4: { label: 'Every 2 months', cadence: 'every 2 months' },
  5: { label: 'Quarterly', cadence: 'every 3 months' },
  6: { label: 'Every 6 months', cadence: 'every 6 months' },
  7: { label: 'Annually', cadence: 'per year' },
  8: { label: 'Every 2 years', cadence: 'every 2 years' },
  9: { label: 'Every 4 months', cadence: 'every 4 months' },
};

export function priceAmount(point, field = 'price') {
  const value = point[field];
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return 'Set price';
  const code = String(point.currency_code || 'USD').toUpperCase();
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: code, minimumFractionDigits: 0 }).format(Number(value));
  } catch (error) {
    return `${point.currency_symbol || code + ' '}${Number(value).toLocaleString('en-US')}`;
  }
}

export function trialDuration(point) {
  const unit = { 1: 'day', 2: 'week', 3: 'month', 4: 'year' }[point.trial_period_type];
  const count = Number(point.trial_period);
  if (!unit || !Number.isFinite(count) || count < 0) return 'the trial period';
  return `${count} ${unit}${count === 1 ? '' : 's'}`;
}

export function trialSummary(point) {
  if (Number(point.type) === 5 || Number(point.is_trial) !== 1) return 'No trial';
  return `${priceAmount(point, 'trial_price')} trial for ${trialDuration(point)}`;
}

export function billingLabel(point) {
  const type = Number(point.type);
  const names = { 1: 'One-time', 2: 'Recurring', 3: 'Installments', 4: 'Recurring installments', 5: 'Pay your own price' };
  const interval = intervals[point.recurring_interval];
  return [2, 3, 4].includes(type)
    ? `${names[type]} - ${interval ? interval.label : 'Choose interval'}`
    : names[type] || 'Choose billing model';
}

export function billingStory(point) {
  const type = Number(point.type);
  const price = priceAmount(point);
  const interval = intervals[point.recurring_interval];
  const cadence = interval ? interval.cadence : '(billing interval not set)';
  let payment;
  if (type === 5) return `Customer chooses the amount, with a minimum of ${price}. One payment at checkout.`;
  if (type === 1) payment = `${price} one-time payment`;
  else if (type === 2) payment = `${price} ${cadence}`;
  else if (type === 3 || type === 4) {
    const count = Number(point.number_of_installments);
    payment = `${count > 0 ? count : 'Set number of'} payment${count === 1 ? '' : 's'} of ${price}, billed ${cadence}`;
    if (type === 4) {
      const recurrence = { 1: 'every year', 2: 'every 2 years' }[point.recurrence_interval];
      payment += `; the installment schedule repeats ${recurrence || '(recurrence not set)'}`;
    }
  } else return 'Choose a billing model to see the payment schedule.';
  return Number(point.is_trial) === 1
    ? `${priceAmount(point, 'trial_price')} trial for ${trialDuration(point)}, then ${payment} starting after ${trialDuration(point)}.`
    : `${payment}. ${type === 1 ? 'Paid' : 'First payment'} at checkout.`;
}

export function pricePointTooltip(point) {
  return `Price point name: ${point.name || 'Not set'}\nInternal description: ${point.internal_name || 'Not set'}\nPrice point description: ${point.description || 'Not set'}\nPayment schedule: ${billingStory(point)}`;
}
